import { render, staticRenderFns } from "./JcsatKitPurchase.vue?vue&type=template&id=a70a612e"
import script from "./JcsatKitPurchase.vue?vue&type=script&lang=js"
export * from "./JcsatKitPurchase.vue?vue&type=script&lang=js"
import style0 from "./JcsatKitPurchase.vue?vue&type=style&index=0&id=a70a612e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports